import React from 'react';
import './SocialMediaStyleElevation.scss';
import instagramIcon from './../../../../static/assets/svg/od-instagram.svg';
import facebookIcon from './../../../../static/assets/svg/od-facebook.svg';

const SocialMediaStyleElevation = () => {
  return (
    <div className="od-social-media">
      <div className="od-social-media__info od-font-reg">
        Elevate your style with <span>#OWNDAYS</span> eyewear! Flaunt your trendy frames and{' '}
        <span>tag us</span> for a chance to shine! 📸✨
      </div>
      <div className="od-social-media__icons">
        <a
          href="https://www.facebook.com/owndays.sg"
          rel="noreferrer"
          target="_blank"
          title="facebook"
        >
          <img alt="instagram" height={48} src={facebookIcon} width={48} />
        </a>
        <a
          href="https://www.instagram.com/owndays_sg"
          rel="noreferrer"
          target="_blank"
          title="facebook"
        >
          <img alt="instagram" height={48} src={instagramIcon} width={48} />
        </a>
      </div>
    </div>
  );
};

export default SocialMediaStyleElevation;
